<a class="flex-one is-flex has-flex-align-center" [ngClass]="{disabled:disabled}" (click)="goBack()" [routerLink]="url" [queryParams]="queryParams" [attr.title]="('navigation.back-to' | translate) + ' ' + (text|async)">
  <div class="back is-flex has-flex-content-center has-flex-align-center">
    <img src="{{img?img:'/assets/icons/general_navigation/back_blue@1x.svg' | staticp}}" [attr.alt]="'navigation.back-to' | translate" />
  </div>
  <div *ngIf="showLabel">
    {{ ((text | async) ? 'navigation.back-to' : 'navigation.back') | translate }} {{ text | async }}
  </div>
</a>
